import React, { Component } from 'react';
import { BlueIconWrapper, Button, PaddedSection, SimpleMarkdown } from '../../atoms';
import { genClassName } from '../../../utils/helpers';
import './styles.css';

/**
 * JoinQr Component
 *
 * @typedef {Object} PiotProgramPoint
 * @prop {Object} image - Image object
 * @prop {string} image.src - Image source path
 * @prop {string} image.alt - Image alt text
 * @prop {string} text - Card title
 *
 * @typedef {Object} Props
 * @prop {PiotProgramPoint[]} pilotProgramPoints - Array of objects to display
 * @prop {string} className - CSS class name
 * @prop {string} heading - Main heading text
 * @prop {string} subHeading - Sub heading text
 * @prop {string} callToActionText - Action text
 * @prop {string} callToActionBtnText - Action btn text
 * @prop {string} href - Btn href
 * @prop {Object} image - Image object
 * @prop {string} image.src - Image source path
 * @prop {string} image.alt - Image alt text
 * @prop {string} [imageClassName] - CSS class name
 *
 * @augments {Component<Props>}
 */

export default class JoinQr extends Component {

	genTextBlock = (pilotProgramPoints) =>
		pilotProgramPoints.map((point, idx) => {
			// eslint-disable-next-line react/no-array-index-key
			return (<div className='pilotProgramPoint' key={idx}>
				<ul className='pointsList'>
					<li className='pointItem'>
						<BlueIconWrapper className='challengePicture' alt={point.image.alt} src={point.image.src} />
						<p className={'pointText'}>{point.text}</p>
					</li>
				</ul>
			</div>);
		});

	render () {
		const {
			heading,
			subHeading,
			className,
			imageClassName,
			pilotProgramPoints,
			callToActionText,
			callToActionBtnText,
			image: {
				src,
				alt,
			},
			href } = this.props;

		return (
			<PaddedSection>
				<div className='headingSection'>
					<h1>{heading}</h1>
					<SimpleMarkdown>
						{subHeading}
					</SimpleMarkdown>
				</div>

				<section className={genClassName('JoinQr', {
					[className]: className,
				})}
				>
					<div
						className={'JoinQr-image'}
					>
						<img
							className={genClassName('', imageClassName)}
							src={require(`../../../assets/images/${src}`)}
							alt={alt}
						/>
					</div>
					<div className='JoinQr-content'>
						{this.genTextBlock(pilotProgramPoints)}
						<p>{callToActionText}</p>
						<Button className='pilotProgram' variant='blue' href={href}>{callToActionBtnText}</Button>
					</div>
				</section>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/JoinQr/JoinQr.js